// Constants
export const info_examens = () => {
  return {
    info_examens: {
      id: {
        description: 'id autoincrement',
        label: 'Id',
        readonly: true,
        type: 'number',
        dataform: ['paciente_agenda','paciente_registrar'],
        datatype: {
          predeterminate: ''
        }
      },
      id_datos_pacientes:{
        type: 'number',
        label: 'Tipo',
        placeholder: '',
        description: 'Tipo de documento',
        validate: 'required',
        dataform: ['paciente_agenda','paciente_registrar'],
        datatype: { 
          disabled: false,
          type: 'select', 
          predeterminate: '',
          list: 'datos_pacientes',
          label: 'name'
        }
      },
      antiguo: {
        type: 'text',
        label: 'estado',
        dataform: ['paciente_pacientes','paciente_garantias'],
        placeholder: '',
        description: 'garantia',
        validate: '',
        datatype: 
        {
          disabled: false,
          predeterminate: '',
        }
      },
      garantia: {
        type: 'text',
        label: 'estado',
        dataform: ['paciente_pacientes','paciente_garantias'],
        placeholder: '',
        description: 'garantia',
        validate: '',
        datatype: 
        {
          disabled: false,
          predeterminate: '',
        }
      },
    }
  }
}

export function asign_info_examens(){
  var asign= Object.keys(info_examens().info_examens);
  var objeto = info_examens().info_examens
  var nuevoArray = {}
  for(var i=0; i<asign.length; i++)
  {
          var createdataform= objeto[asign[i]].dataform
          for(var j=0; j<createdataform.length;  j++)
          {
                  nuevoArray[createdataform[j]] = {}
          }
  }        
  return nuevoArray
}

